<template>
  <b-card>
    <validation-observer ref="profileDataForm">
      <b-form ref="profileDataFormElement" @submit.prevent="save">
        <b-row>
          <b-col md="6">
            <b-form-group :label="t('Name')" label-for="firstname">
              <validation-provider
                #default="{ errors }"
                :name="t('Name')"
                vid="firstname"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="firstname"
                    v-model="values.firstName"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="firstname"
                    :placeholder="t('Name')"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="t('Surname')" label-for="surname">
              <validation-provider
                #default="{ errors }"
                :name="t('Surname')"
                vid="surname"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="surname"
                    v-model="values.lastName"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="surname"
                    :placeholder="t('Surname')"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="t('Email')" label-for="email">
              <validation-provider #default="{ errors }" :name="t('Email')" vid="email">
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="email"
                    v-model="values.email"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="email"
                    :placeholder="t('Email')"
                    readonly
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="t('Customer')" label-for="customer_name">
              <validation-provider #default="{ errors }" :name="t('Customer')" vid="customer_name">
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="customer_name"
                    v-model="customerName"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="customer_name"
                    :placeholder="t('Customer')"
                    readonly
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-1 mr-1"
              type="submit"
              :disabled="requestIsLoading"
            >
              {{ requestIsLoading ? t('Loading') : t('Save Changes') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BInputGroup
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import Ripple from 'vue-ripple-directive';
import useService from '@/auth/service/useService';

export default {
  directives: {
    Ripple
  },

  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [helper],

  data() {
    return {
      values: {},
      roles: '',
      customerName: '',
      requestIsLoading: false
    };
  },

  created() {
    this.accountData();
  },

  methods: {
    accountData() {
      this.requestIsLoading = true;

      useService
        .me({})
        .then(response => {
          this.values = response.data;
          this.customerName = this.values.customer.name;
          [this.roles] = this.values.roles;
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.requestIsLoading = false;
        });
    },
    save() {
      this.$refs.profileDataForm.validate().then(success => {
        if (success) {
          this.requestIsLoading = true;

          useService
            .updatePersonalData({
              firstname: this.values.firstName,
              lastname: this.values.lastName
            })
            .then(response => {
              this.showSuccessMessage(
                `${response.message || this.$t('Operation Complete Successfully')}`
              );
              this.$store.dispatch('auth/me');
            })
            .catch(messages => {
              if (typeof messages === 'object' && messages && messages.length) {
                messages.forEach(item => {
                  this.showErrorMessage(item.message);
                });
              }
            })
            .finally(() => {
              this.requestIsLoading = false;
            });
        }
      });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
